import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function DetailMaterial({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const material = useSelector((state) => state.material);

  useEffect(() => {
    dispatch(actions.materialGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (material.isLoading || material.rows) {
    return <Loading />;
  }
  if (!material.isLoading && material.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
          <div className="text-lg font-semibold ml-6">ข้อมูลวัตถุดิบ</div>
        </div>
        <div>
          <Card className="p-4 ">
            <div className="flex flex-wrap divide-y">
              <div className="w-full py-4 text-lg font-semibold ">
                {'รายละเอียด'}
              </div>
              <div className="w-1/2 py-4 px-2 font-semibold ">
                {'รหัสวัตถุดิบ'}
              </div>
              <div className="w-1/2 py-4 ">{`${material?.type_code}`}</div>
              <div className="w-1/2 py-4 px-2 font-semibold ">{'ชื่อ'}</div>
              <div className="w-1/2 py-4 ">{`${material?.name}`}</div>
              {material?.detail ? (
                <>
                  <div className="w-1/2 py-4 px-2 font-semibold ">
                    {'รายละเอียด'}
                  </div>
                  <div className="w-1/2 py-4 ">{`${material?.detail}`}</div>
                </>
              ) : (
                <></>
              )}
              <div className="w-1/2 py-4 px-2 font-semibold ">{'หน่วย'}</div>
              <div className="w-1/2 py-4 ">{`${material?.unit}`}</div>
              <div className="w-1/2 py-4 px-2 font-semibold ">
                {'ประเภทวัตถุดิบ'}
              </div>
              <div className="w-1/2 py-4 ">{`${material?.material_type?.name}`}</div>
              {material?.net ? (
                <>
                  <div className="w-1/2 py-4 px-2 font-semibold ">
                    {'ปริมาตรสุทธิ'}
                  </div>
                  <div className="w-1/2 py-4 ">{`${material?.net} ${material?.unit_net}`}</div>
                </>
              ) : (
                <></>
              )}
              <div className="w-1/2 py-4 px-2 font-semibold ">
                {'จำนวนขั้นต่ำของวัตถุดิบ'}
              </div>
              <div className="w-1/2 py-4 ">{`${material?.minimum_amount} ${material?.unit}`}</div>
            </div>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

DetailMaterial.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DetailMaterial.defaultProps = {
  title: '',
  subtitle: '',
};
